import { render, staticRenderFns } from "./TicketAssigned.vue?vue&type=template&id=7a5d1d6d&scoped=true"
import script from "./TicketAssigned.vue?vue&type=script&lang=js"
export * from "./TicketAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5d1d6d",
  null
  
)

export default component.exports